import { UserDeviceType } from '@/types';

export interface AgentDeviceStatusHistoryReportServiceGetInfoParams {
    startDate: string;
    endDate: string;
}

export interface AgentDeviceStatusHistoryReportDeviceInfo {
    userDeviceId: number;
    deviceType: UserDeviceType;
    totalConnectedTime: number;
}

export interface AgentDeviceStatusHistoryReportServiceGetInfoResult {
    userId: number;
    name: string;
    extension: string;
    userDevices: AgentDeviceStatusHistoryReportDeviceInfo[];
    totalConnectedTime: number;
    totalPauseTime: number;
    totalCallDuration: number;
}
